<div class="modal-submit-giveaway d-flex flex-column" [ngClass]="{'background': !showErrorMessage}">
    <i class="btn-close pt-3-sa icon-edponline-Bop-071" card-modal="dismiss()" (click)="closeModal(false)"  aria-hidden="true"></i>
    <div *ngIf="loading">
        <edp-loader [size]="'md'" [position]="'center'"></edp-loader>
    </div>
    <ng-container *ngIf="!loading">
        <ng-container *ngIf="!showErrorMessage">
            <div class="d-flex flex-row">
                <div class="left-side align-self-center">
                    <img alt="" src="{{card.image}}" class="image d-block d-md-none image mh-100 p-2 mx-auto" />
                    <span
                        class="title">{{ 'pt.edp.edponline.modal.submit.giveaway.title' | translate: {"card.name": card.name } }}</span>
                    <span class="description" [innerHTML]="card.description"></span>
                    <span
                        class="sub-description">{{ 'pt.edp.edponline.modal.submit.giveaway.subdescription' | translate}}{{ card.dateValidationEnd }}</span>
                    <form class="edp-form d-flex flex-column mb-3 pt-3">
                        <div class="form-group mb-4">
                            <label class="form-check-label pl-5">
                                <span class="condition-terms">
                                    {{ 'Register.terms1' | translate }}
                                    <a class="edp-text-seaweed-green" [edpExternalLink]="card.termsAndConditions" [isFile]="true">{{ 'pt.edp.edponline.benefits.termsAndConditions' | translate }}</a>.
                                </span>
                                <input class="form-check-input" type="checkbox" id="form-terms"
                                    (change)="onClick($event)" />
                                <span class="form-check-mark"></span>
                            </label>
                        </div>

                        <button impersonateDisable class="btn btn-primary submit-button" type="button"
                            (click)="submit()" [disabled]="!conditionTermsChecked">
                            {{ 'pt.edp.edponline.modal.submit.giveaway.button' | translate }}
                        </button>
                    </form>
                </div>
                <div class="right-side d-none d-md-block">
                    <img alt="" src="{{card.image}}" class="image mh-100 p-2 ml-auto" />
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="showErrorMessage">
            <div class="w-100 align-items-center d-flex flex-column" *ngIf="success">
                <i class="icon green icon-edponline-Bop-072"  aria-hidden="true"></i>
                <span class="message-title green"
                    [innerHTML]="'pt.edp.edponline.modal.submit.giveaway.success.title' | translate: {'card.name': card.name}">
                </span>
                <span class="message-description mb-0"
                    [innerHTML]="'pt.edp.edponline.modal.submit.giveaway.success.description' | translate: {'card.dateValidationEnd': card.dateValidationEnd}">
                </span>
            </div>
            <div class="w-100 align-items-center d-flex flex-column" *ngIf="!success">
                <i class="icon red icon-edponline-Bop-025"  aria-hidden="true"></i>
                <span
                    class="message-title red">{{ 'pt.edp.edponline.modal.submit.giveaway.error.title' | translate }}</span>
                <span
                    class="message-description">{{ 'pt.edp.edponline.modal.submit.giveaway.error.description' | translate }}</span>
                    <button impersonateDisable class="btn btn-primary submit-button" type="button"
                    (click)="submit()">
                    {{ 'pt.edp.edponline.modal.submit.giveaway.error.button' | translate }}
                </button>
            </div>
        </ng-container>
        <ng-container *ngIf="btnLink && card.location === 'dashboard'">
            <div class="text-center cta mb-4 pt-5 font-weight-bold cursor-pointer" card-modal="dismiss()"
                [routerLink]="benefits.route" [queryParams]="benefits.param" (click)="onClickLink(benefits)">
                {{ "pt.edp.edponline.modal.submit.giveaway.link" | translate }}
                <i class="ml-wdgt-2 icon-edponline-Bop-073 rotate-270" [ngStyle]="{ 'margin-top': '-0.3rem' }"  aria-hidden="true"></i>
            </div>
        </ng-container>
    </ng-container>
</div>